module.exports = __webpack_public_path__ + "static/media/home-team-ns.058e2bdc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-team-ns.jpg
// module id = 1606
// module chunks = 0